var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03752 0H17.9625C18.5346 0.00304165 19 0.463851 19 1.02656V11.9734C19 12.5377 18.5299 13 17.9563 13H1.03752C0.46696 12.997 0 12.5361 0 11.9734V1.02656C0 0.463851 0.465413 0.00304165 1.03752 0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.33289H19V8.66723H0V4.33289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.66711H19V11.9734C19 12.5376 18.5299 12.9999 17.9563 12.9999H1.03752C0.46696 12.9969 0 12.5361 0 11.9734V8.66711Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2627 6.49997C11.2627 5.54186 10.4741 4.76624 9.5 4.76624C8.52588 4.76624 7.7373 5.54186 7.7373 6.49997C7.7373 7.45657 8.52588 8.23371 9.5 8.23371C10.4741 8.23371 11.2627 7.45809 11.2627 6.49997Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0412 6.50003C11.0412 5.66205 10.3516 4.98376 9.49959 4.98376C8.64762 4.98376 7.95801 5.66205 7.95801 6.50003C7.95801 7.338 8.64762 8.01629 9.49959 8.01629C10.3516 8.01629 11.0412 7.338 11.0412 6.50003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80778 6.49997C9.80778 6.33267 9.67017 6.1958 9.50008 6.1958C9.33 6.1958 9.19238 6.33115 9.19238 6.49997C9.19238 6.66726 9.33 6.80261 9.50008 6.80261C9.67017 6.80261 9.80778 6.66726 9.80778 6.49997Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.105 6.70838C11.1112 6.66732 11.0803 6.6293 11.0385 6.62321C10.9968 6.61713 10.9581 6.64755 10.952 6.68861C10.9458 6.72967 10.9767 6.76769 11.0184 6.77377C11.0617 6.77834 11.1004 6.74944 11.105 6.70838Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49984 8.01623L9.55241 7.10677L9.49984 6.67334L9.44727 7.10677L9.49984 8.01623Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.995 7.10985C11.012 7.07183 10.9919 7.0262 10.9533 7.011C10.9146 6.99427 10.8682 7.01404 10.8528 7.05206C10.8358 7.09008 10.8559 7.1357 10.8945 7.15091C10.9347 7.16612 10.9796 7.14787 10.995 7.10985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 7.9645L9.39225 7.09915L9.45565 6.66724L9.2902 7.0733L9.10156 7.9645Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7849 7.47025C10.8112 7.43679 10.805 7.38965 10.771 7.36379C10.737 7.33794 10.6891 7.34402 10.6628 7.37748C10.6365 7.41094 10.6427 7.45808 10.6767 7.48394C10.7107 7.50979 10.7586 7.50219 10.7849 7.47025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72852 7.81394L9.23722 7.05201L9.41195 6.65051L9.146 6.99878L8.72852 7.81394Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4849 7.76384C10.5189 7.73799 10.5251 7.69084 10.4988 7.65739C10.4725 7.62393 10.4246 7.61785 10.3905 7.6437C10.3565 7.66955 10.3503 7.7167 10.3766 7.75016C10.4029 7.78209 10.4524 7.7897 10.4849 7.76384Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41016 7.57216L9.10132 6.96535L9.375 6.62317L9.0271 6.89235L8.41016 7.57216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1203 7.9722C10.1589 7.95547 10.179 7.91137 10.162 7.87335C10.145 7.83533 10.1002 7.81556 10.0615 7.83229C10.0229 7.84749 10.0028 7.89312 10.0198 7.93114C10.0352 7.96916 10.0801 7.98741 10.1203 7.9722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 7.25887L8.99284 6.84825L9.34692 6.58667L8.93872 6.75852L8.16406 7.25887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71207 8.07865C9.75382 8.07256 9.7832 8.03454 9.77856 7.99348C9.77237 7.95242 9.73372 7.92352 9.69197 7.92809C9.65022 7.93417 9.62084 7.97219 9.62548 8.01325C9.63012 8.05583 9.66878 8.08473 9.71207 8.07865Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01074 6.8924L8.91838 6.70686L9.32967 6.54565L8.89054 6.60649L8.01074 6.8924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28865 8.07858C9.3304 8.08467 9.36905 8.05425 9.37524 8.01319C9.38142 7.97213 9.3505 7.93411 9.30875 7.92802C9.267 7.92194 9.22835 7.95236 9.22216 7.99342C9.21752 8.036 9.2469 8.07402 9.28865 8.07858Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95801 6.49995L8.88265 6.55166L9.32332 6.49995L8.88265 6.44824L7.95801 6.49995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8802 7.9722C8.91886 7.98893 8.96525 7.96916 8.98071 7.93114C8.99617 7.89312 8.97762 7.84749 8.93896 7.83229C8.9003 7.81556 8.85392 7.83533 8.83845 7.87335C8.82299 7.91137 8.84155 7.95547 8.8802 7.9722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01074 6.10767L8.89054 6.39358L9.32967 6.45593L8.91838 6.29321L8.01074 6.10767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51345 7.76384C8.54746 7.7897 8.5954 7.78361 8.62168 7.75016C8.64797 7.7167 8.64178 7.66955 8.60777 7.6437C8.57375 7.61785 8.52582 7.62393 8.49953 7.65739C8.47479 7.69084 8.48098 7.73799 8.51345 7.76384Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 5.74109L8.93872 6.24144L9.34692 6.41329L8.99284 6.15171L8.16406 5.74109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21504 7.47025C8.24132 7.50371 8.28925 7.50979 8.32327 7.48394C8.35729 7.45808 8.36347 7.41094 8.33719 7.37748C8.3109 7.34402 8.26297 7.33794 8.22895 7.36379C8.19648 7.38813 8.18875 7.43679 8.21504 7.47025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41016 5.42786L9.0271 6.10766L9.375 6.37837L9.10132 6.03467L8.41016 5.42786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00349 7.10985C8.0205 7.14787 8.06534 7.16764 8.104 7.15091C8.14265 7.13418 8.16276 7.09008 8.14575 7.05206C8.12874 7.01404 8.0839 6.99427 8.04524 7.011C8.00659 7.0262 7.98803 7.07031 8.00349 7.10985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72852 5.18604L9.146 6.0012L9.41195 6.34947L9.23722 5.94949L8.72852 5.18604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89535 6.70832C7.90154 6.74938 7.94019 6.77828 7.98194 6.77372C8.02369 6.76763 8.05307 6.72961 8.04843 6.68855C8.04224 6.64749 8.00359 6.61859 7.96184 6.62315C7.91855 6.62772 7.88917 6.66574 7.89535 6.70832Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 5.0354L9.2902 5.92812L9.45565 6.33266L9.39225 5.90075L9.10156 5.0354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89532 6.2917C7.88914 6.33276 7.92006 6.37078 7.96181 6.37687C8.00356 6.38295 8.04221 6.35253 8.0484 6.31147C8.05458 6.27041 8.02366 6.23239 7.98191 6.2263C7.93861 6.22174 7.89996 6.25064 7.89532 6.2917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49984 4.98376L9.44727 5.89322L9.49984 6.32665L9.55241 5.89322L9.49984 4.98376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00512 5.89017C7.98811 5.92819 8.00821 5.97382 8.04686 5.98902C8.08552 6.00423 8.13191 5.98598 8.14737 5.94796C8.16438 5.90994 8.14427 5.86432 8.10562 5.84911C8.06542 5.8339 8.02058 5.85215 8.00512 5.89017Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89901 5.0354L9.60832 5.90075L9.54492 6.33266L9.71037 5.92812L9.89901 5.0354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2155 5.53129C8.18921 5.56475 8.1954 5.61189 8.22942 5.63775C8.26343 5.6636 8.31137 5.65752 8.33765 5.62406C8.36394 5.5906 8.35775 5.54345 8.32374 5.5176C8.28972 5.49175 8.24179 5.49783 8.2155 5.53129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2713 5.18604L9.76261 5.94949L9.58789 6.34947L9.85384 6.0012L10.2713 5.18604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51457 5.23619C8.48056 5.26205 8.47437 5.30919 8.50066 5.34265C8.52694 5.37611 8.57487 5.38219 8.60889 5.35634C8.64291 5.33048 8.64909 5.28334 8.62281 5.24988C8.59652 5.21642 8.54704 5.21186 8.51457 5.23619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5898 5.42786L9.89868 6.03467L9.625 6.37837L9.9729 6.10766L10.5898 5.42786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8802 5.0294C8.84155 5.04612 8.82299 5.09023 8.83845 5.12825C8.85546 5.16627 8.9003 5.18604 8.93896 5.16931C8.97762 5.15258 8.99772 5.10848 8.98071 5.07046C8.96525 5.03092 8.9204 5.01267 8.8802 5.0294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8362 5.74109L10.0074 6.15171L9.65332 6.41329L10.0615 6.24144L10.8362 5.74109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28865 4.92143C9.2469 4.92751 9.21752 4.96553 9.22216 5.0066C9.22835 5.04766 9.267 5.07655 9.30875 5.07199C9.3505 5.06591 9.38142 5.02789 9.37524 4.98683C9.3706 4.94576 9.33194 4.91535 9.28865 4.92143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9889 6.10767L10.0812 6.29321L9.66992 6.45593L10.109 6.39358L10.9889 6.10767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7114 4.92143C9.66965 4.91535 9.631 4.94576 9.62481 4.98683C9.61863 5.02789 9.64955 5.06591 9.6913 5.07199C9.73305 5.07807 9.7717 5.04766 9.77789 5.0066C9.78253 4.96553 9.75315 4.92599 9.7114 4.92143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0421 6.49995L10.1174 6.44824L9.67676 6.49995L10.1174 6.55166L11.0421 6.49995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1203 5.02931C10.0816 5.01258 10.0352 5.03235 10.0198 5.07037C10.0028 5.10839 10.0229 5.15401 10.0615 5.16922C10.1002 5.18443 10.1466 5.16618 10.162 5.12816C10.1775 5.08862 10.1589 5.04452 10.1203 5.02931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9889 6.8924L10.109 6.60649L9.66992 6.54565L10.0812 6.70686L10.9889 6.8924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4849 5.23623C10.4509 5.21037 10.4029 5.21646 10.3766 5.24992C10.3503 5.28337 10.3565 5.33052 10.3905 5.35637C10.4246 5.38223 10.4725 5.37614 10.4988 5.34269C10.5251 5.30923 10.5189 5.26208 10.4849 5.23623Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8362 7.25887L10.0615 6.75852L9.65332 6.58667L10.0074 6.84825L10.8362 7.25887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7849 5.53129C10.7586 5.49783 10.7107 5.49175 10.6767 5.5176C10.6427 5.54345 10.6365 5.5906 10.6628 5.62406C10.6891 5.65752 10.737 5.6636 10.771 5.63775C10.8035 5.61189 10.8112 5.56323 10.7849 5.53129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5898 7.57216L9.9729 6.89235L9.625 6.62317L9.89868 6.96535L10.5898 7.57216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.997 5.89019C10.98 5.85217 10.9351 5.8324 10.8965 5.84913C10.8578 5.86586 10.8377 5.90996 10.8547 5.94799C10.8717 5.98601 10.9166 6.00426 10.9552 5.98905C10.9939 5.97384 11.0124 5.92973 10.997 5.89019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2713 7.81394L9.85384 6.99878L9.58789 6.65051L9.76261 7.05201L10.2713 7.81394Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1047 6.2917C11.0985 6.25064 11.0599 6.22174 11.0181 6.2263C10.9764 6.23239 10.947 6.27041 10.9517 6.31147C10.9578 6.35253 10.9965 6.38143 11.0382 6.37687C11.0815 6.3723 11.1109 6.33428 11.1047 6.2917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89901 7.9645L9.71037 7.0733L9.54492 6.66724L9.60832 7.09915L9.89901 7.9645Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.ffe3d9b709c3f2f07a217a091a9c806e.svg";
export { ForwardRef as ReactComponent };